import React from 'react';
import styled from 'styled-components';

const LoadingDotsContainer = styled.div`
  display: flex;
  gap: 4px;
  padding: 8px 12px;
`;

const Dot = styled.div`
  animation: pulse 1s ease-in-out infinite;
  background: ${p => p.theme.colors.gray400};
  border-radius: 50%;
  height: 6px;
  width: 6px;

  @keyframes pulse {
    0%,
    80%,
    100% {
      opacity: 0.3;
    }
    40% {
      opacity: 1;
    }
  }
`;

export function TeamAssistLoadingDots() {
  return (
    <LoadingDotsContainer data-aid="teamAssistLoadingDots">
      <Dot style={{ animationDelay: '0s' }} />
      <Dot style={{ animationDelay: '0.2s' }} />
      <Dot style={{ animationDelay: '0.4s' }} />
    </LoadingDotsContainer>
  );
}

export { LoadingDotsContainer, Dot };
